// import apiClient from "./api";

// export const getCelebrities = async (page = 1, limit = 10, search = "") => {
//   try {
//     let url = `/celebs/list-celebs?page=${page}&limit=${limit}`;

//     if (search && search.trim() !== "") {
//       url += `&search=${encodeURIComponent(search.trim())}`;
//     }

//     const response = await apiClient.get(url);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching celebrities:", error);
//     throw error.response?.data || { message: "Failed to fetch celebrities" };
//   }
// };

// export const getCelebrityById = async (id) => {
//   try {
//     const response = await apiClient.get(`/celebs/${id}`);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching celebrity:", error);
//     throw error.response?.data || { message: "Failed to fetch celebrity" };
//   }
// };


import apiClient from "./api";

export const getCelebrities = async (page = 1, limit = 10, search = "") => {
  try {
    let url = `/celebs/list-celebs?page=${page}&limit=${limit}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching celebrities:", error);
    throw error.response?.data || { message: "Failed to fetch celebrities" };
  }
};

export const getCelebritiesNoAuth = async (
  page = 1,
  limit = 10,
  search = ""
) => {
  try {
    let url = `/celebs/list-celebs-no-auth?page=${page}&limit=${limit}`;

    if (search && search.trim() !== "") {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching celebrities (no auth):", error);
    throw error.response?.data || { message: "Failed to fetch celebrities" };
  }
};

export const getCelebrityById = async (id) => {
  try {
    const response = await apiClient.get(`/celebs/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching celebrity:", error);
    throw error.response?.data || { message: "Failed to fetch celebrity" };
  }
};